module.exports =
  machine:
    base: '/internal/embr/machine'
    detail: '/internal/embr/machine/:machineName/detail'
    stitch: '/internal/embr/machine/:machineName/stitch'
    storage:
      check: '/internal/embr/machine/storage/check'
  color:
    code:
      bulk: '/internal/embr/color/code/bulk'
  zsk:
    prepareStitch: '/internal/embr/zsk/prepareStitch'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/embrServer.coffee